const APP_VERSION = "0.1.0";

export function Footer() {
  return (
    <footer className="border-t bg-card px-6 py-2 text-center text-xs text-muted-foreground">
      <span>CISPay · Admin de Recursos · v{APP_VERSION}</span>
      <span className="mx-2 opacity-50">·</span>
      <span>© {new Date().getFullYear()} CISPay</span>
    </footer>
  );
}
